import request from '../request'

export const getRoles = () => request.get('roles').then((res) => res)

export const createCustomRole = (data = {}) => request.post('roles/custom', data).then((res) => res)

export const updateCustomRole = (roleId, data = {}) =>
  request.put(`roles/custom/${roleId}`, data).then((res) => res)

export const deleteCustomRole = (roleId) => request.delete(`roles/custom/${roleId}`).then((res) => res)

// MF-576 — roles editor (Maestro only)
export const getRolesEditor = () => request.get('roles/editor').then((res) => res)

export const saveRoleEditor = (roleId, modules) =>
  request.put(`roles/editor/${roleId}`, { modules }).then((res) => res)

export const resetRoleEditor = (roleId) => request.delete(`roles/editor/${roleId}`).then((res) => res)
